import { createServerFn } from "@tanstack/react-start";

export const CONTACT_TOPICS = [
  "Request support",
  "Contact sales",
  "Boards & Heat (ranking)",
  "Get Hot / listing submission",
  "Billing, invoices & payments",
  "Wallets, payouts & withdrawals",
  "Referral programme",
  "Promote (creator promotion)",
  "Earn (creator payouts)",
  "Marketplace (coming soon)",
  "Fund (crowdfunding, coming soon)",
  "Press & partnerships",
  "Report a listing / trust & safety",
  "Privacy & data request",
  "Something else",
] as const;

export type ContactTopic = (typeof CONTACT_TOPICS)[number];

export const submitContactMessage = createServerFn({ method: "POST" })
  .inputValidator(
    (data: {
      topic: string;
      name: string;
      email: string;
      company?: string;
      message: string;
    }) => {
      const topic = String(data?.topic ?? "").trim();
      const name = String(data?.name ?? "").trim();
      const email = String(data?.email ?? "").trim().toLowerCase();
      const company = String(data?.company ?? "").trim();
      const message = String(data?.message ?? "").trim();

      if (!(CONTACT_TOPICS as readonly string[]).includes(topic))
        throw new Error("Please choose what your enquiry is about.");
      if (name.length < 2) throw new Error("Please enter your name.");
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email))
        throw new Error("Please enter a valid email address.");
      if (message.length < 10) throw new Error("Please add a few more details to your message.");
      if (message.length > 5000) throw new Error("Message is too long (5000 characters max).");

      return { topic, name, email, company: company.slice(0, 160), message };
    },
  )
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { sendTemplateEmail } = await import("./email-templates/send-email");

    const { data: row, error } = await supabaseAdmin
      .from("contact_messages")
      .insert({
        topic: data.topic,
        name: data.name,
        email: data.email,
        company: data.company || null,
        message: data.message,
      })
      .select("id")
      .single();

    if (error) throw new Error("We could not send your message. Please try again.");

    try {
      await sendTemplateEmail("contact-message", "vincenzo@picciuolo.it", {
        templateData: {
          topic: data.topic,
          name: data.name,
          email: data.email,
          company: data.company,
          message: data.message,
          submittedAt: new Date().toLocaleString("en-GB", { timeZone: "Asia/Dubai" }),
        },
        idempotencyKey: `contact-${row.id}`,
        replyTo: data.email,
      });
    } catch (err) {
      console.error("contact email failed", err);
    }

    return { ok: true as const };
  });
